import "app.css";
import { LoadedApp } from "loadedApp";
import { MarginHitWrapper } from "wrappers/marginHitWrapper";

export const App = () => (
  <MarginHitWrapper>
    <LoadedApp />
  </MarginHitWrapper>
);
